<template>
    <!-- 手机端卡片风格版本 -->
    <div class="mobile-container" v-if="isMobile">
        <!-- 顶部查询区域 -->
        <div class="search-section">
            <el-input v-model="serialNumber" maxlength="12" placeholder="输入12位SN，留空查最近锁号" show-word-limit type="text"
                class="search-input" />
            <div class="button-group">
                <el-button type="primary" @click="fetchData" class="action-btn">查询 X431</el-button>
                <el-button type="primary" plain @click="getBlackSnHandle" class="action-btn">查询 XK</el-button>
            </div>
        </div>

        <div class="mobile-stats">
            <div class="stat-card">
                <span class="stat-label">锁号总数</span>
                <strong>{{ statsLoading ? '...' : totalBlackCountText }}</strong>
                <el-button link type="primary" size="small" :loading="exportLoading"
                    :disabled="statsLoading || exportLoading" @click="exportAllBlackSn">导出全部</el-button>
            </div>
            <div class="stat-card north-america-stat">
                <span class="stat-label">已确认北美</span>
                <strong>{{ statsLoading ? '...' : northAmericaCountText }}</strong>
                <el-button link type="primary" size="small" :disabled="statsLoading"
                    @click="showNorthAmericaList">查看全部</el-button>
            </div>
            <div class="stat-card">
                <span class="stat-label">已确认非北美</span>
                <strong>{{ statsLoading ? '...' : nonNorthAmericaCountText }}</strong>
            </div>
            <div class="stat-card">
                <span class="stat-label">MyCar 无记录</span>
                <strong>{{ statsLoading ? '...' : notFoundCountText }}</strong>
            </div>
            <div class="stat-card">
                <span class="stat-label">查询失败待重试</span>
                <strong>{{ statsLoading ? '...' : queryErrorCountText }}</strong>
            </div>
            <div class="stat-card">
                <span class="stat-label">待查询</span>
                <strong>{{ statsLoading ? '...' : pendingCountText }}</strong>
            </div>
            <div class="version-summary">
                <div class="summary-title">版本锁号数</div>
                <div v-if="versionStats.length" class="version-split-list version-chip-list">
                    <div class="version-column">
                        <button v-for="item in versionGroups.left" :key="`left-${item.rawVersion}`" type="button"
                            class="version-chip" :disabled="statsLoading" @click="showVersionList(item)">
                            {{ item.displayVersion }}: {{ item.count }}
                        </button>
                    </div>
                    <div class="version-column mazda-version-column">
                        <button v-for="item in versionGroups.right" :key="`right-${item.rawVersion}`" type="button"
                            class="version-chip" :disabled="statsLoading" @click="showVersionList(item)">
                            {{ item.displayVersion }}: {{ item.count }}
                        </button>
                    </div>
                </div>
                <span v-else class="summary-empty">暂无版本数据</span>
            </div>
        </div>

        <!-- 添加黑名单按钮 -->
        <div class="add-section">
            <el-button type="primary" :icon="Edit" @click="dialogFormVisible = true" class="add-btn">添加黑名单接头</el-button>
        </div>

        <!-- 卡片列表 -->
        <div class="card-list">
            <div v-for="(item, index) in filterTableData" :key="index" class="blacklist-card">
                <div class="card-header">
                    <span class="sn">{{ item.sn }}</span>
                    <el-popconfirm title="确认删除?" @confirm="handleDelete(index, item)">
                        <template #reference>
                            <el-button type="danger" :icon="Delete" circle size="small" class="delete-btn" />
                        </template>
                    </el-popconfirm>
                </div>
                <div class="card-content">
                    <div class="info-row">
                        <span class="label">封号原因：</span>
                        <span class="value reason">{{ item.ban_reason }}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">使用版本：</span>
                        <span class="value version-tag">{{ displayRowVersion(item.version) }}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">封号时间：</span>
                        <span class="value">{{ item.ban_time }}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">服务器：</span>
                        <span class="value server-tag">{{ item.server }}</span>
                    </div>
                </div>
            </div>

            <!-- 空状态 -->
            <div v-if="filterTableData.length === 0" class="empty-state">
                <el-empty description="暂无数据" />
            </div>
        </div>

        <!-- 添加黑名单弹窗 -->
        <el-dialog v-model="dialogFormVisible" title="提交黑名单用户" width="90%" class="mobile-dialog" append-to-body>
            <el-form :model="form">
                <el-form-item label="接头:" label-width="60px">
                    <el-input v-model="form.sn" autocomplete="off" maxlength="12" show-word-limit />
                </el-form-item>
                <el-form-item label="原因:" label-width="60px">
                    <el-input v-model="form.info" autocomplete="off" maxlength="9999" show-word-limit type="textarea"
                        :rows="3" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="handleSubmit">提交</el-button>
                </span>
            </template>
        </el-dialog>
    </div>

    <!-- 桌面端 -->
    <div v-else class="desktop-container">
        <!-- 顶部操作栏 -->
        <div class="desktop-toolbar">
            <div class="toolbar-left">
                <el-input v-model="serialNumber" maxlength="12" placeholder="输入12位SN，留空查最近锁号" show-word-limit
                    type="text" class="desktop-search-input" />
                <el-button type="primary" @click="fetchData" class="desktop-action-btn">查询 X431</el-button>
                <el-button type="primary" plain @click="getBlackSnHandle" class="desktop-action-btn">查询 XK</el-button>
            </div>
            <div class="toolbar-right">
                <el-button type="primary" :icon="Edit" @click="dialogFormVisible = true"
                    class="desktop-add-btn">添加黑名单接头</el-button>
            </div>
        </div>

        <div class="desktop-stats">
            <div class="stat-item">
                <span class="stat-label">当前服务器</span>
                <strong>{{ activeServer || '未查询' }}</strong>
            </div>
            <div class="stat-item">
                <span class="stat-label">锁号总数</span>
                <strong>{{ statsLoading ? '统计中...' : totalBlackCountText }}</strong>
                <el-button link type="primary" size="small" :loading="exportLoading"
                    :disabled="statsLoading || exportLoading" @click="exportAllBlackSn">导出全部</el-button>
            </div>
            <div class="stat-item north-america-stat">
                <span class="stat-label">已确认北美</span>
                <strong>{{ statsLoading ? '统计中...' : northAmericaCountText }}</strong>
                <el-button link type="primary" size="small" :disabled="statsLoading"
                    @click="showNorthAmericaList">查看全部</el-button>
            </div>
            <div class="stat-item">
                <span class="stat-label">已确认非北美</span>
                <strong>{{ statsLoading ? '统计中...' : nonNorthAmericaCountText }}</strong>
            </div>
            <div class="stat-item">
                <span class="stat-label">MyCar 无记录</span>
                <strong>{{ statsLoading ? '统计中...' : notFoundCountText }}</strong>
            </div>
            <div class="stat-item">
                <span class="stat-label">查询失败待重试</span>
                <strong>{{ statsLoading ? '统计中...' : queryErrorCountText }}</strong>
            </div>
            <div class="stat-item">
                <span class="stat-label">待查询</span>
                <strong>{{ statsLoading ? '统计中...' : pendingCountText }}</strong>
            </div>
            <div class="version-stat-panel">
                <span class="stat-label">各版本锁号数</span>
                <div v-if="versionStats.length" class="desktop-version-list version-split-list">
                    <div class="version-column">
                        <button v-for="item in versionGroups.left" :key="`left-${item.rawVersion}`" type="button"
                            class="version-pill" :disabled="statsLoading" @click="showVersionList(item)">
                            {{ item.displayVersion }}: {{ item.count }}
                        </button>
                    </div>
                    <div class="version-column mazda-version-column">
                        <button v-for="item in versionGroups.right" :key="`right-${item.rawVersion}`" type="button"
                            class="version-pill" :disabled="statsLoading" @click="showVersionList(item)">
                            {{ item.displayVersion }}: {{ item.count }}
                        </button>
                    </div>
                </div>
                <span v-else class="summary-empty">暂无版本数据</span>
            </div>
        </div>

        <!-- 表格区域 - 总宽度 735px -->
        <div class="desktop-table-wrapper">
            <el-table :data="filterTableData" stripe border style="width: 825px"
                :header-cell-style="{ background: '#f8fafc', color: '#1e293b', fontWeight: '600', fontSize: '14px' }"
                :cell-style="{ padding: '12px 0' }" empty-text="暂无数据">
                <el-table-column prop="sn" label="Sn" width="125" header-align="center" align="center" />
                <el-table-column prop="ban_reason" label="封号原因" width="250" header-align="center" align="center" />
                <el-table-column prop="version" label="使用版本" width="100" header-align="center" align="center">
                    <template #default="scope">
                        <span>{{ displayRowVersion(scope.row.version) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ban_time" label="封号时间" width="180" header-align="center" align="center" />
                <el-table-column prop="server" label="服务器" width="80" header-align="center" align="center" />
                <el-table-column label="操作" width="90" header-align="center" align="center">
                    <template #default="scope">
                        <el-popconfirm title="确认删除?" @confirm="handleDelete(scope.$index, scope.row)">
                            <template #reference>
                                <el-button type="danger" :icon="Delete" circle size="small" />
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 添加黑名单弹窗 -->
        <el-dialog v-model="dialogFormVisible" title="提交黑名单用户" width="500px" class="desktop-dialog" append-to-body>
            <el-form :model="form">
                <el-form-item label="接头:" :label-width="formLabelWidth">
                    <el-input v-model="form.sn" autocomplete="off" maxlength="12" show-word-limit />
                </el-form-item>
                <el-form-item label="原因:" :label-width="formLabelWidth">
                    <el-input v-model="form.info" autocomplete="off" maxlength="9999" show-word-limit type="textarea"
                        :rows="4" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="handleSubmit">提交</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { ref, computed, reactive, onMounted, onUnmounted } from 'vue';
import { Edit, Delete } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getBlackSn, getBlackSnStats, downloadBlackSnTxt, addBlackSn, deleteBlackSn, getSomeOne, deleteSomeOne } from '../api/users';
import {
    displayVersionName,
    northAmericaRowsFromStats,
    splitVersionStatsByMazdaPrefix,
    versionRowsFromStats
} from '../utils/blackSn.mjs';

export default {
    setup() {
        const activeServer = ref('X431');
        const formLabelWidth = '60px'
        const dialogFormVisible = ref(false);
        const form = reactive({
            sn: '',
            info: ''
        })

        const serialNumber = ref('');
        const search = ref('');

        const tableData = ref([]);
        const blackStats = ref(null);
        const statsLoading = ref(false);
        const exportLoading = ref(false);

        // 响应式判断手机端
        const isMobile = ref(window.innerWidth <= 768);

        const handleResize = () => {
            isMobile.value = window.innerWidth <= 768;
        };

        onMounted(() => {
            window.addEventListener('resize', handleResize);
            loadBlackStats(activeServer.value);
        });

        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });

        const filterTableData = computed(() =>
            tableData.value.filter(
                (data) =>
                    !search.value ||
                    String(data.sn || '').toLowerCase().includes(search.value.toLowerCase())
            )
        );

        const versionStats = computed(() => {
            const stats = blackStats.value?.versionStats;
            if (Array.isArray(stats) && stats.length) {
                return stats.map((item) => ({
                    version: item.version || '未知',
                    count: Number(item.count || 0)
                }));
            }

            const countMap = new Map();
            filterTableData.value.forEach((item) => {
                const version = String(item.version || '未知').trim() || '未知';
                countMap.set(version, (countMap.get(version) || 0) + 1);
            });

            return Array.from(countMap, ([version, count]) => ({ version, count }))
                .sort((left, right) => right.count - left.count || left.version.localeCompare(right.version));
        });

        const versionGroups = computed(() =>
            splitVersionStatsByMazdaPrefix(versionStats.value)
        );

        const displayRowVersion = (version) => displayVersionName(version);

        const totalBlackCountText = computed(() => {
            if (blackStats.value?.total === undefined || blackStats.value?.total === null) {
                return '未统计';
            }

            return blackStats.value.total;
        });

        const northAmericaCountText = computed(() => {
            if (blackStats.value?.northAmericaCount === undefined) {
                return '未统计';
            }
            return Number(blackStats.value.northAmericaCount || 0);
        });

        const nonNorthAmericaCountText = computed(() => {
            if (blackStats.value?.nonNorthAmericaCount === undefined) {
                return '未统计';
            }
            return Number(blackStats.value.nonNorthAmericaCount || 0);
        });

        const notFoundCountText = computed(() => {
            if (blackStats.value?.notFoundCount === undefined) {
                return '未统计';
            }
            return Number(blackStats.value.notFoundCount || 0);
        });

        const queryErrorCountText = computed(() => {
            if (blackStats.value?.queryErrorCount === undefined) {
                return '未统计';
            }
            return Number(blackStats.value.queryErrorCount || 0);
        });

        const pendingCountText = computed(() => {
            if (blackStats.value?.pendingCount !== undefined) {
                return Number(blackStats.value.pendingCount || 0);
            }
            const legacyPending = blackStats.value?.uncachedFilialeCount
                ?? blackStats.value?.northAmericaUncachedCount;
            return legacyPending === undefined
                ? '未统计'
                : Number(legacyPending || 0);
        });

        const normalizeBlackRows = (rows, serverName) => {
            if (!Array.isArray(rows)) {
                return [];
            }

            return rows.map((row) => ({
                ...row,
                server: row.server || serverName
            }));
        };

        const loadBlackStats = async (serverName) => {
            statsLoading.value = true;

            try {
                const response = await getBlackSnStats(`${serverName} Server`);
                blackStats.value = response.data || null;
            } catch (error) {
                blackStats.value = null;
                ElMessage.warning('黑名单统计失败');
            } finally {
                statsLoading.value = false;
            }
        };

        const showNorthAmericaList = () => {
            const rows = northAmericaRowsFromStats(
                blackStats.value,
                activeServer.value
            );
            tableData.value = rows;
            serialNumber.value = '';

            if (rows.length) {
                ElMessage.success(`已显示 ${rows.length} 个北美接头`);
            } else {
                ElMessage.info('当前服务器暂无已确认北美接头');
            }
        };

        const showVersionList = (item) => {
            const rows = versionRowsFromStats(
                blackStats.value,
                item.rawVersion || item.version,
                activeServer.value,
                50
            );
            const versionLabel =
                item.displayVersion || displayVersionName(item.version);

            tableData.value = rows;
            serialNumber.value = '';

            if (rows.length) {
                ElMessage.success(
                    `已显示 ${versionLabel} 最新 ${rows.length} 条锁号`
                );
            } else {
                ElMessage.info(`当前服务器暂无 ${versionLabel} 明细`);
            }
        };

        const exportAllBlackSn = async () => {
            exportLoading.value = true;
            try {
                const serverName = activeServer.value === 'XK'
                    ? 'XK Server'
                    : 'X431 Server';
                await downloadBlackSnTxt(serverName);
                ElMessage.success('黑名单序列号 TXT 已开始下载');
            } catch (error) {
                ElMessage.warning('导出失败，请稍后重试');
            } finally {
                exportLoading.value = false;
            }
        };

        const getQuerySn = () => {
            const value = serialNumber.value.trim();

            if (!value) {
                return 'all';
            }

            if (value.length !== 12) {
                ElMessage.error('请输入12位有效序列号，或留空查询最近锁号');
                return '';
            }

            return value;
        };

        const fetchData = async () => {
            activeServer.value = 'X431';
            const querySn = getQuerySn();
            if (!querySn) {
                return;
            }

            try {
                loadBlackStats('X431');
                getBlackSn(100, querySn)
                    .then(response => {
                        if (response.data.isblack) {
                            tableData.value = normalizeBlackRows(response.data.tableData, 'X431');
                            ElMessage.success('查询成功！');
                        } else {
                            tableData.value = [];
                            ElMessage.success('已查询,非黑名单用户!');
                        }
                    })
                    .catch(error => {
                        ElMessage.error('查询接头失败！');
                    });
            } catch (error) {
                ElMessage({ type: 'error', message: '查询接头失败，请稍后重试' });
            }
        };

        const getBlackSnHandle = async () => {
            activeServer.value = 'XK';
            const querySn = getQuerySn();
            if (!querySn) {
                return;
            }

            try {
                loadBlackStats('XK');
                const response = await getSomeOne('XK Server', `getBlackSn?limit=100&sn=${querySn}`);

                if (response.data.isblack) {
                    tableData.value = normalizeBlackRows(response.data.tableData, 'XK');
                    ElMessage.success('查询成功！');
                } else {
                    tableData.value = [];
                    ElMessage.success('已查询,非黑名单用户!');
                }
            } catch (error) {
                ElMessage({ type: 'warning', message: '查询接头失败，请稍后重试' });
            }
        };

        const handleDelete = async (index, row) => {
            try {
                const value = row.sn;
                if (activeServer.value === 'X431') {
                    await deleteBlackSn(value);
                    ElMessage({ type: 'success', message: '已同步到CN/US服务器中', })
                } else {
                    await deleteSomeOne('XK Server', `deleteBlackSn/${value}`);
                    ElMessage({ type: 'success', message: '已同步到XK服务器中', })
                }

                tableData.value = tableData.value.filter((item) => item.sn !== value);
                if (activeServer.value) {
                    loadBlackStats(activeServer.value);
                }
            } catch (error) {
                ElMessage({ type: 'warning', message: '删除失败，请重试', })
            }
        };

        const handleSubmit = async () => {
            try {
                if (!form.sn || form.sn.length !== 12) {
                    ElMessage({ type: 'warning', message: '接头必须为12位字符' });
                    return;
                }
                if (!form.info || form.info.trim() === '') {
                    ElMessage({ type: 'warning', message: '原因不能为空' });
                    return;
                }
                const serialNumberValues = { sn: form.sn, ban_reason: form.info };
                await addBlackSn(serialNumberValues);
                ElMessage({ type: 'success', message: '已同步到CN/US服务器中' });
                dialogFormVisible.value = false;
                form.sn = '';
                form.info = '';

                // 提交成功后刷新当前查询
                if (activeServer.value === 'X431') {
                    fetchData();
                } else if (activeServer.value === 'XK') {
                    getBlackSnHandle();
                }
            } catch (error) {
                ElMessage({ type: 'warning', message: '请求失败，请重试' });
            }
        };

        return {
            search,
            filterTableData, tableData,
            versionStats,
            versionGroups,
            displayRowVersion,
            totalBlackCountText,
            northAmericaCountText,
            nonNorthAmericaCountText,
            notFoundCountText,
            queryErrorCountText,
            pendingCountText,
            statsLoading,
            exportLoading,
            handleDelete,
            Edit,
            Delete,
            ElMessage, ElMessageBox,
            serialNumber, fetchData,
            dialogFormVisible, formLabelWidth, form, handleSubmit, getBlackSnHandle,
            showNorthAmericaList,
            showVersionList,
            exportAllBlackSn,
            activeServer,
            isMobile
        };
    }
};
</script>

<style scoped>
/* ========== 桌面端样式 ========== */
.desktop-container {
    padding: 12px 24px 24px 12px;
    margin-right: auto;
    width: fit-content;
    box-sizing: border-box;
}

.desktop-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 20px;
    background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    border: 1px solid #e2e8f0;
    width: 870px;
    box-sizing: border-box;
}

.desktop-stats {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 20px;
    width: 870px;
}

.stat-item,
.version-stat-panel {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
    box-sizing: border-box;
}

.stat-item {
    min-height: 78px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.stat-label {
    color: #64748b;
    font-size: 13px;
    font-weight: 600;
}

.stat-item strong {
    color: #0f172a;
    font-size: 22px;
    line-height: 1.2;
    word-break: break-word;
}

.stat-item :deep(.el-button),
.stat-card :deep(.el-button) {
    align-self: flex-start;
    height: auto;
    padding: 0;
    font-weight: 600;
}

.version-stat-panel {
    grid-column: 1 / -1;
}

.desktop-version-list,
.version-chip-list {
    margin-top: 10px;
}

.version-split-list {
    display: grid;
    grid-template-columns: minmax(0, max-content) minmax(0, max-content);
    column-gap: 28px;
    row-gap: 10px;
    align-items: start;
    justify-content: start;
}

.version-column {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    min-width: 0;
}

.version-pill,
.version-chip {
    display: inline-flex;
    align-items: center;
    min-height: 28px;
    padding: 4px 10px;
    border-radius: 8px;
    background: #eff6ff;
    color: #1d4ed8;
    border: 1px solid #bfdbfe;
    font-size: 13px;
    font-weight: 600;
    box-sizing: border-box;
    font-family: inherit;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.version-pill:hover:not(:disabled),
.version-chip:hover:not(:disabled) {
    background: #dbeafe;
    border-color: #60a5fa;
    transform: translateY(-1px);
}

.version-pill:disabled,
.version-chip:disabled {
    cursor: not-allowed;
    opacity: 0.65;
}

.summary-empty {
    display: inline-block;
    margin-top: 10px;
    color: #94a3b8;
    font-size: 13px;
}

.toolbar-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.toolbar-right {
    display: flex;
    align-items: center;
}

.desktop-search-input {
    width: 220px;
}

.desktop-search-input :deep(.el-input__wrapper) {
    border-radius: 10px;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    transition: all 0.3s ease;
    box-shadow: none;
}

.desktop-search-input :deep(.el-input__wrapper:hover),
.desktop-search-input :deep(.el-input__wrapper.is-focus) {
    border-color: #409eff;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
    background-color: #ffffff;
}

.desktop-action-btn {
    border-radius: 10px;
    height: 36px;
    font-weight: 500;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
}

.desktop-action-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.desktop-add-btn {
    border-radius: 10px;
    height: 36px;
    font-weight: 500;
    background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.25);
    transition: all 0.3s ease;
}

.desktop-add-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(64, 158, 255, 0.35);
}

.desktop-table-wrapper {
    background: #ffffff;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    border: 1px solid #e2e8f0;
    width: 870px;
    box-sizing: border-box;
}

.desktop-table-wrapper :deep(.el-table) {
    border-radius: 12px;
    overflow: hidden;
}

.desktop-table-wrapper :deep(.el-table th) {
    font-size: 14px;
    letter-spacing: 0.5px;
}

.desktop-table-wrapper :deep(.el-table td) {
    font-size: 13px;
    color: #475569;
}

.desktop-table-wrapper :deep(.el-table .el-table__row--striped) {
    background-color: #f8fafc;
}

.desktop-table-wrapper :deep(.el-table .el-table__row:hover) {
    background-color: #e0f2fe;
}

.desktop-dialog :deep(.el-dialog) {
    border-radius: 16px;
    overflow: hidden;
}

.desktop-dialog :deep(.el-dialog__header) {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    padding: 20px;
    margin: 0;
    border-bottom: 1px solid #e2e8f0;
}

.desktop-dialog :deep(.el-dialog__title) {
    font-size: 17px;
    font-weight: 600;
    color: #1e293b;
}

.desktop-dialog :deep(.el-dialog__body) {
    padding: 24px;
}

.desktop-dialog :deep(.el-input__wrapper),
.desktop-dialog :deep(.el-textarea__inner) {
    border-radius: 10px;
}

/* ========== 手机端卡片风格样式 ========== */
.mobile-container {
    padding: 12px;
    background-color: #f5f7fa;
    min-height: 100vh;
    box-sizing: border-box;
}

/* 搜索区域 */
.search-section {
    background-color: #ffffff;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.mobile-stats {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 16px;
}

.stat-card,
.version-summary {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 14px;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
}

.stat-card {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.stat-card strong {
    color: #0f172a;
    font-size: 22px;
    line-height: 1.2;
    word-break: break-word;
}

.version-summary {
    grid-column: 1 / -1;
}

.summary-title {
    color: #64748b;
    font-size: 13px;
    font-weight: 600;
}

.search-input {
    margin-bottom: 14px;
}

.search-input :deep(.el-input__wrapper) {
    border-radius: 12px;
    padding: 6px 16px;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    box-shadow: none;
    transition: all 0.3s ease;
}

.search-input :deep(.el-input__wrapper:hover),
.search-input :deep(.el-input__wrapper.is-focus) {
    border-color: #409eff;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
    background-color: #ffffff;
}

.search-input :deep(.el-input__inner) {
    font-size: 15px;
    height: 44px;
}

.button-group {
    display: flex;
    gap: 10px;
}

.action-btn {
    flex: 1;
    border-radius: 12px;
    height: 44px;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
}

.action-btn:active {
    transform: scale(0.98);
}

/* 添加区域 */
.add-section {
    margin-bottom: 16px;
}

.add-btn {
    width: 100%;
    border-radius: 16px;
    height: 48px;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
    border: none;
    box-shadow: 0 6px 16px rgba(64, 158, 255, 0.25);
    letter-spacing: 1px;
    transition: all 0.3s ease;
}

.add-btn:active {
    transform: scale(0.98);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 卡片列表 */
.card-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding-bottom: 20px;
}

.blacklist-card {
    background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
    border-radius: 20px;
    padding: 18px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(226, 232, 240, 0.8);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.blacklist-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(180deg, #409eff 0%, #337ecc 100%);
    border-radius: 4px 0 0 4px;
}

.blacklist-card:active {
    transform: scale(0.99);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid #edf0f5;
}

.sn {
    font-size: 17px;
    font-weight: 700;
    color: #1e293b;
    letter-spacing: 1px;
    background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: 'Monaco', 'Courier New', monospace;
}

.delete-btn {
    background-color: #fef0f0;
    border: 1px solid #fecaca;
    color: #f56c6c;
    transition: all 0.3s ease;
    width: 32px;
    height: 32px;
}

.delete-btn:hover {
    background-color: #f56c6c;
    color: #ffffff;
    border-color: #f56c6c;
    transform: rotate(90deg);
}

.delete-btn:active {
    transform: rotate(90deg) scale(0.9);
}

.card-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.info-row {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    line-height: 1.6;
}

.label {
    width: 75px;
    color: #64748b;
    flex-shrink: 0;
    font-weight: 500;
    font-size: 13px;
}

.value {
    color: #334155;
    word-break: break-word;
    flex: 1;
    font-size: 14px;
}

.reason {
    color: #d97706;
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    padding: 4px 10px;
    border-radius: 8px;
    display: inline-block;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid #fbbf24;
}

.version-tag {
    display: inline-block;
    background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
    color: #4338ca;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 600;
    align-self: flex-start;
    border: 1px solid #a5b4fc;
    letter-spacing: 0.5px;
}

.server-tag {
    display: inline-block;
    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
    color: #1d4ed8;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 600;
    align-self: flex-start;
    border: 1px solid #93c5fd;
    letter-spacing: 0.5px;
}

/* 空状态 */
.empty-state {
    background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
    border-radius: 20px;
    padding: 40px 0;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.empty-state :deep(.el-empty__description p) {
    color: #94a3b8;
    font-size: 15px;
}

/* 移动端弹窗 */
.mobile-dialog :deep(.el-dialog) {
    border-radius: 20px;
    overflow: hidden;
}

.mobile-dialog :deep(.el-dialog__header) {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    padding: 20px;
    margin: 0;
    border-bottom: 1px solid #e2e8f0;
}

.mobile-dialog :deep(.el-dialog__title) {
    font-size: 17px;
    font-weight: 600;
    color: #1e293b;
}

.mobile-dialog :deep(.el-dialog__body) {
    padding: 24px 20px;
}

.mobile-dialog :deep(.el-form-item) {
    margin-bottom: 22px;
}

.mobile-dialog :deep(.el-form-item__label) {
    font-weight: 600;
    color: #475569;
    font-size: 14px;
}

.mobile-dialog :deep(.el-input__wrapper),
.mobile-dialog :deep(.el-textarea__inner) {
    border-radius: 12px;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    transition: all 0.3s ease;
}

.mobile-dialog :deep(.el-input__wrapper:hover),
.mobile-dialog :deep(.el-textarea__inner:hover),
.mobile-dialog :deep(.el-input__wrapper.is-focus),
.mobile-dialog :deep(.el-textarea__inner:focus) {
    border-color: #409eff;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
}

.dialog-footer {
    display: flex;
    gap: 12px;
    padding: 0 20px 20px;
}

.dialog-footer .el-button {
    flex: 1;
    border-radius: 12px;
    height: 44px;
    font-size: 15px;
    font-weight: 500;
}

/* 桌面端隐藏移动端样式 */
@media screen and (min-width: 769px) {
    .mobile-container {
        display: none;
    }
}

/* 平板和手机适配 */
@media screen and (max-width: 768px) {
    .desktop-container {
        display: none;
    }

    .search-section {
        padding: 16px;
    }

    .sn {
        font-size: 16px;
    }

    .card-content {
        gap: 8px;
    }
}

/* 全局动画 */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.blacklist-card {
    animation: fadeInUp 0.3s ease;
}
</style>
